if (!('async' in window)) {
    import('regenerator-runtime/runtime');
}
import('./main.js')